import * as yup from 'yup'
import { i18WithDefault as t } from '../shared'

export const signUpSchema = yup.object({
  email: yup.string().email(t('password.email.error')).required(t('password.emailRequired.error')),
  password: yup.string().min(8, t('password.minLength.error')).required(t('password.required.error')),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], t('password.matching.error'))
    .required(t('password.required.error')),
})

export const initialValues = (email: string = '') => {
  return {
    email: email,
    password: '',
    confirmPassword: '',
  }
}
